import {
  Box,
  Chip,
  TextField,
  Autocomplete,
  useTheme,
  Paper,
} from '@mui/material';
import { i18n } from '../../translate/i18n';

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const theme = useTheme();

  const queues = (userQueues || []).sort((a, b) => a.id - b.id);

  const selectedQueues = queues
    .filter((q) => selectedQueueIds.includes(q.id))
    .sort((a, b) => a.id - b.id);

  const handleChange = (event, value) => {
    onChange(value.map((v) => v.id));
  };

  return (
    <Box style={{ padding: '2.5px 10px 10px' }}>
      <Autocomplete
        multiple
        size='small'
        options={queues}
        value={selectedQueues}
        onChange={handleChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                key={key}
                variant='outlined'
                sx={{
                  backgroundColor: option.color || '#bfbfbf',
                  textShadow: '1px 1px 1px #000',
                  color: '#FFF',
                }}
                label={option.name}
                {...tagProps}
                size='small'
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            placeholder={i18n.t('ticketsQueueSelect.placeholder')}
            sx={theme.custom.selectField}
          />
        )}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              backgroundColor: theme.custom.colors.defaultBackground,
              '& .MuiAutocomplete-listbox': {
                color: theme.custom.colors.text,
              },
            }}
          >
            {children}
          </Paper>
        )}
      />
    </Box>
  );
};

export default TicketsQueueSelect;
